/**
 * Compiles snippets and chunks from different areas of the database (plugins, Divi settings, etc.)
 */

// WPCode Lite - Gravity Form Phone Validation
jQuery(document).ready(function($) {
    $('input[name="input_25"]').on('input', function() {
        this.value = this.value.replace(/D/g, '');
    });
});


// Video script from Divi > Theme Options header code field
jQuery(document).ready(function() {
    if (jQuery('.joy-video-autoplay .et_pb_video_box').length !== 0) {
        jQuery('.joy-video-autoplay .et_pb_video_box').find('video').prop('muted', true);
        jQuery(".joy-video-autoplay .et_pb_video_box").find('video').attr('playsInline', '');
        jQuery(".joy-video-autoplay .et_pb_video_box").find('video').attr('loop', 'loop');
        jQuery(".joy-video-autoplay .et_pb_video_box").each(function() {
            jQuery(this).find('video').get(0).play();
        });
        jQuery('.joy-video-autoplay .et_pb_video_box').find('video').removeAttr('controls');
    }
});

// WPGB refresh on page load for filter params in incoming URL
jQuery(document).ready(function($) {
    if (window.location.href.indexOf("ajax=true") > -1) {
        console.log("ajax true");
        $(document).on('wpgb.init', function() {
            console.log("wpgb refreshing...");
            wpgb.ajax.refresh();
        });
    }
});

